<template>
  <section class="cms-body">
    <el-form
      ref="form"
      :model="dataInfo"
      :rules="rules"
      class="cms-form"
      label-width="162px"
    >
      <el-form-item label="设备标识" class="flex-50">
        <el-input v-model="dataInfo.guid" :readonly="true"></el-input>
        <span class="gray">系统自动生成，无需填写</span>
      </el-form-item>
      <el-form-item label="设备名称" class="flex-50" prop="dev_name">
        <el-input v-model="dataInfo.dev_name"></el-input>
      </el-form-item>

      <el-form-item label="设备编号" class="flex-50" prop="dev_code">
        <el-input v-model="dataInfo.dev_code"></el-input>
      </el-form-item>
      <el-form-item label="所属分组" class="flex-50" prop="gid">
        <el-select v-model="dataInfo.gid" placeholder="请选择">
          <el-option
            v-for="item in groups"
            :key="item.gid"
            :label="
              item.group_name +
                '-' +
                item.user_name +
                '[' +
                item.role_name +
                ']'
            "
            :value="item.gid"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="设备类型" class="flex-50" prop="dtid">
        <el-select
          v-model="dataInfo.dtid"
          placeholder="请选择"
          @change="typeChange"
        >
          <el-option
            v-for="item in types"
            :key="item.dtid"
            :label="item.type_name"
            :value="item.dtid"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务器" class="flex-50">
        <el-input v-model="serverName" :readonly="true"></el-input>
        <span class="gray">自动关联到设备类型，无需填写，不可修改</span>
      </el-form-item>

      <el-form-item label="设备图片" class="flex-50">
        <cmsPicture
          :picurl="picUrl"
          :showcancel="showCancel"
          @btnClick="openPicDiag()"
          @picCancel="picCancel()"
          @picReset="picCancel()"
        ></cmsPicture>
      </el-form-item>
      <el-form-item label="变量配置" class="flex-50">
        <div style="line-height:152px;">
          <el-button
            type="primary"
            size="small"
            @click="varDialog = true"
            :disabled="!this.isLoadVars"
            >配置类型变量</el-button
          >
          <span class="gray">
            指定设备类型后，方可进行配置；不配置默认加载对应设备类型的全部变量
          </span>
        </div>
      </el-form-item>

      <el-form-item label="经度" class="flex-50" prop="dev_lng">
        <el-input v-model="dataInfo.dev_lng" :readonly="true">
          <el-button
            type="info"
            plain
            slot="append"
            class="el-icon-location-outline"
            @click="openDialog()"
          >
          </el-button>
        </el-input>
        <span class="gray">不可手动输入，需从地图上拾取</span>
      </el-form-item>
      <el-form-item label="纬度" class="flex-50" prop="dev_lat">
        <el-input v-model="dataInfo.dev_lat" :readonly="true">
          <el-button
            type="info"
            plain
            slot="append"
            class="el-icon-location-outline"
            @click="openDialog()"
          >
          </el-button>
        </el-input>
        <span class="gray">不可手动输入，需从地图上拾取</span>
      </el-form-item>

      <el-form-item label="设备型号" class="flex-50">
        <el-input v-model="dataInfo.dev_no"></el-input>
      </el-form-item>
      <el-form-item label="激活码" class="flex-50">
        <el-input v-model="dataInfo.dev_authcode"></el-input>
      </el-form-item>

      <el-form-item label="视频链接" class="flex-100">
        <el-input v-model="dataInfo.video_url"></el-input>
      </el-form-item>
      <!-- <el-form-item v-show="isadmin" label="组态地址" class="flex-50">
        <el-input v-model="dataInfo.view_url"></el-input>
      </el-form-item> -->

      <el-form-item label="设备地址" class="flex-50">
        <el-input
          v-model="dataInfo.dev_address"
          type="textarea"
          :rows="6"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" class="flex-50">
        <el-input
          v-model="dataInfo.dev_des"
          type="textarea"
          :rows="6"
        ></el-input>
      </el-form-item>

      <div class="form-footer">
        <el-button type="warning" @click="add(true)">保存并继续添加</el-button>
        <el-button type="primary" @click="add(false)">提交</el-button>
        <el-button type="info" @click="reset">重置</el-button>
        <el-button type="info" @click="$router.go(-1)">返回</el-button>
        <span class="gray">
          选择“提交并继续添加”按钮会停留在添加页面；选择“提交”按钮后将跳转到对应的列表页</span
        >
      </div>
    </el-form>
    <!-- 图片选择 -->
    <el-dialog title="图片选择" :visible.sync="picDialog">
      <cmsPictureList
        :total="total"
        :tableData="tableData"
        @picClick="picClick"
        @change="getPages"
      ></cmsPictureList>
    </el-dialog>
    <!-- 地图位置选择 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      width="50%"
      height="50%"
    >
      <baidu-map
        v-bind:style="{ height: myheight }"
        :center="{ lng: 105.0, lat: 38.0 }"
        :zoom="4"
        :scroll-wheel-zoom="true"
        @click="mapClick"
        @resize="mapResize"
      >
        <bm-marker :position="markerPoint" :dragging="false" :show="true">
        </bm-marker>
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :isOpen="true">
        </bm-overview-map>
        <bm-map-type
          :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
          anchor="BMAP_ANCHOR_TOP_LEFT"
        >
        </bm-map-type>
      </baidu-map>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getLnglat">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设备变量配置 -->
    <el-dialog
      title="默认变量配置"
      :visible.sync="varDialog"
      @opened="openedCallback"
    >
      <cmsVarList
        ref="varlist"
        :varList="varList"
        :guid="dataInfo.guid"
        :selectVcids="vcids"
        @getIds="getVcids"
      ></cmsVarList>
    </el-dialog>
  </section>
</template>
<script>
import va from "@/rules";
import formMixns from "@/mixins/form";
import listMixins from "@/mixins/list";

export default {
  mixins: [formMixns, listMixins], //普通表单变量
  data() {
    let required = va.required("此项必填");
    let number = va.number("只能输入数字");
    let double = va.double("只能是浮点型数字");
    let validateCode = va.validateCode("设备名已存在", "Device/IsExist", "");
    return {
      myheight: window.innerHeight / 2 + "px",
      dialogVisible: false,
      servers: [],
      types: [],
      groups: [],
      rules: {
        //校验规则
        guid: [required],
        dev_name: [required],
        dev_code: [required, validateCode],
        uid: [required, number],
        sid: [required, number],
        gid: [required, number],
        dtid: [required, number],
        dev_lng: [double],
        dev_lat: [double]
      },
      isadmin: false,
      markerPoint: {//存放地图拾取的point
        lng: 105.0,
        lat: 38.0
      },
      serverName: "",
      varDialog: false, //配置默认变量
      vcids: "", //存放当前设备选择使用的系统变量（挂靠在）
      varList: [], //当前设备类型挂靠的变量数组
      isLoadVars: false, //是否成功加载varList
      params: {
        pageNo: "1",
        pageSize: "10"
      },
      picDialog: false, //选取图片
      picUrl: "",
      showCancel: false
    };
  },
  methods: {
    add(state) {
      //重写方法，将选择的隶属变量类型的变量传递到后台
      let form = this.$refs["form"];
      let self = this;
      form.validate(valid => {
        //验证方法
        if (valid) {
          self.$api
            .post("Device/Insert", { val: self.dataInfo, vcids: self.vcids })
            .then(res => {
              if (res.status == "200") {
                self.$alert("添加成功");
                if (state) {
                  self.reset();
                } else {
                  setTimeout(() => {
                    self.$router.push("/dev/list");
                  }, 1000);
                }
              }
            })
            .catch(error => {});
        } else {
          return false;
        }
      });
    },
    reset() {
      this.dataInfo = {};
    },
    loadOptions() {
      this.$api
        .post("Server")
        .then(res => {
          if (res.status === 200) {
            this.loading = false;
            this.servers = res.data.Data;
          }
        })
        .catch(err => {
          this.loading = false;
        });

      this.$api
        .post("DevType/View",{uid:this.$store.state.userInfo.id})
        .then(res => {
          if (res.status === 200) {
            this.loading = false;
            this.types = res.data.Data;
          }
        })
        .catch(err => {
          this.loading = false;
        });

      this.$api
        .post("Group/View", {
          uid: this.$store.state.userInfo.id
        })
        .then(res => {
          if (res.status === 200) {
            this.loading = false;
            this.groups = res.data.Data;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    openDialog() {
      this.dialogVisible = true;
    },
    mapClick(e) {
      this.markerPoint = e.point; //存放point,/更新当前锚点
      this.center=this.markerPoint;//更新当前地图中心点
    },
    mapResize(type, target, size) {
      this.center = this.markerPoint; //更新当前地图中心点
    },
    getLnglat() {
      this.dataInfo.dev_lng = this.markerPoint.lng;
      this.dataInfo.dev_lat = this.markerPoint.lat;
      this.dialogVisible = false;
    },
    typeChange(e) {
      this.isLoadVars = false;
      if (this.dataInfo.dtid) {
        this.$api.post("VarConf", { dtid: this.dataInfo.dtid }).then(res => {
          if (res.status === 200) {
            this.varList = res.data.Data.list;
            this.isLoadVars = true;
          }
        });
      }
      //获取type中的server
      var obj = this.types.find(function(item) {
        return String(item.dtid) === String(e);
      });

      this.serverName = obj.server_code + ":" + obj.server_name;
    },
    openPicDiag() {
      this.picDialog = true;
    },
    picClick(id, url) {
      this.dataInfo.tpid = id;
      this.picUrl = url;
      this.showCancel = true;
    },
    picCancel() {
      this.dataInfo.tpid = null;
      this.picUrl = "";
      this.showCancel = false;
    },
    getVcids(ids, dshow) {
      //控制模态框
      this.varDialog = dshow;
      //获取要显示的vcid
      this.vcids = ids;
    },
    openedCallback() {
      //触发子组件函数，也可以传参
      //预加载变量列表
      this.$refs["varlist"].getData(); 
    }
  },
  created() {
    //初始获取数据
    this.loadOptions();
    this.isadmin = this.$isAdmin();
    //获取图片
    this.params.uid = this.$store.state.userInfo.id;
    this.initTableData("Picture/PagedView", this.params);
  }
};
</script>
